function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

function getServiceWorkerUrl() {
  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${publicUrl}/serviceworker.js`;
}

async function getNotificationRegistration() {
  if (!('serviceWorker' in navigator)) {
    return null;
  }

  if (navigator.serviceWorker.getRegistration) {
    const existingRegistration = await navigator.serviceWorker.getRegistration();
    if (existingRegistration) {
      return existingRegistration;
    }
  }

  if (navigator.serviceWorker.register) {
    return navigator.serviceWorker.register(getServiceWorkerUrl());
  }

  return navigator.serviceWorker.ready;
}

export async function ensureNotificationSubscription() {
  if (!('Notification' in window) || !('PushManager' in window) || !('serviceWorker' in navigator)) {
    return null;
  }

  if (window.Notification.permission !== 'granted') {
    return null;
  }

  const registration = await getNotificationRegistration();

  if (!registration?.pushManager) {
    return null;
  }

  const existingSubscription = await registration.pushManager.getSubscription();
  if (existingSubscription) {
    return existingSubscription;
  }

  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_NOTIFICATION_PUBLIC_VAPID_KEY),
  });
}
